import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import Table from '../../components/Table';
import { useSelector } from 'react-redux';

function AccountsCenter() {
  const [accountsCenter, setAccountsCenter] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const nameProperty = useSelector((state) => state.nameProperty.nameProperty);

  const columns = [
    {
      title: 'Código',
      field: 'cod',
      editable: 'never',
      hideFilterIcon: true,
    },
    {
      title: 'Descrição',
      field: 'description',
      hideFilterIcon: true,
    },
    {
      title: 'Tipo',
      field: 'type',
      editable: 'never',
      hideFilterIcon: true,
      render: (rowData) => (rowData.type === '1' ? 'Entrada' : 'Saída'),
    },
    {
      title: 'Analítica',
      field: 'analytical',
      editable: 'never',
      hideFilterIcon: true,
      render: (rowData) => (rowData.analytical === true
        ? (rowData.status = 'Sim')
        : (rowData.status = 'Não')),
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/accounts-center');
        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          const data = await response.data;
          const organizedData = await data.map((_element) => ({
            cod: _element.cod,
            description: _element.description,
            type: _element.type === '1' ? 'Entrada' : 'Saída',
            analytical: _element.analytical === true ? 'Sim' : 'Não',
          }));
          setExportData(organizedData);
          setAccountsCenter(data);
          setOpenProgress(true);
        }
      } catch (err) {

      }
    }
    loadData();
  }, [nameProperty]);

  function setData(newData) {
    const tempData = [];
    accountsCenter.map((accountcenter) => (accountcenter.id === newData.id
      ? tempData.push(newData)
      : tempData.push(accountcenter)));
    setAccountsCenter(tempData);
  }

  return (
    <Table
      title="Centros de custo"
      route="/accounts-center/"
      routeAdd="/account-center/"
      columns={columns}
      data={accountsCenter}
      setData={setData}
      dataLoaded={openProgress}
      exportData={exportData}
    />
  );
}

export default AccountsCenter;
